import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconText1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconText1"><Path d="M3.5 5.5V3.5H12H20.5V5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 20.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 20.5H12H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconText1;
